import React, { createRef, useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { Sidebar, StyledSidebar, StyledLink, PageTitle, LinkList, ListItem } from './sidenav.styled';
gsap.registerPlugin(ScrollTrigger);
var Sidenav = function Sidenav(_ref) {
    var pageTitle = _ref.pageTitle, body = _ref.body;
    var sidebar = /*#__PURE__*/ createRef();
    var sidebarLinks = useRef([]);
    useEffect(function () {
        ScrollTrigger.matchMedia({
            '(min-width: 1200px)': function minWidth1200px() {
                ScrollTrigger.create({
                    trigger: 'body',
                    start: 0,
                    end: 'bottom bottom',
                    pin: sidebar.current,
                    invalidateOnRefresh: true
                });
                body.forEach(function (_ref2, index) {
                    var primary = _ref2.primary;
                    var guidelines_title = primary.guidelines_title;
                    var encodedId = encodeURIComponent(guidelines_title);
                    var module = document.getElementById(encodedId);
                    var sidebarLink = sidebarLinks.current[index];
                    ScrollTrigger.create({
                        trigger: module,
                        start: function start() {
                            var _sidebar$current;
                            var sidebarTopPosition = (_sidebar$current = sidebar.current) === null || _sidebar$current === void 0 ? void 0 : _sidebar$current.offsetTop;
                            return sidebarTopPosition ? "top top+=" + sidebarTopPosition : 'top bottom';
                        },
                        end: function end() {
                            var _sidebar$current2;
                            var sidebarTopPosition = (_sidebar$current2 = sidebar.current) === null || _sidebar$current2 === void 0 ? void 0 : _sidebar$current2.offsetTop;
                            return sidebarTopPosition ? "bottom top+=" + sidebarTopPosition : 'top top';
                        },
                        onToggle: function onToggle(_ref3) {
                            var isActive = _ref3.isActive;
                            if (sidebarLink && isActive) {
                                sidebarLinks.current.forEach(function (el) {
                                    el === null || el === void 0 ? void 0 : el.setAttribute('style', 'color: var(--muted);');
                                });
                                sidebarLink.setAttribute('style', 'color: var(--primary);');
                            }
                        },
                        invalidateOnRefresh: true
                    });
                });
            }
        });
    });
    return /*#__PURE__*/ React.createElement(Sidebar, null, /*#__PURE__*/ React.createElement(StyledSidebar, {
        ref: sidebar
    }, /*#__PURE__*/ React.createElement(PageTitle, null, pageTitle), /*#__PURE__*/ React.createElement(LinkList, null, body.map(function (_ref4, index) {
        var id = _ref4.id, primary = _ref4.primary;
        var title = primary.guidelines_title;
        var encodedId = encodeURIComponent(title);
        return /*#__PURE__*/ React.createElement(ListItem, {
            key: id
        }, /*#__PURE__*/ React.createElement(StyledLink, {
            ref: function ref(el) {
                sidebarLinks.current[index] = el;
            },
            href: "#" + encodedId
        }, title));
    }))));
};
export default Sidenav;
